import { MessageMiddlewareBuilder } from "./message-middleware";

export function joinMiddlewares(middlewares: readonly MessageMiddlewareBuilder[]): MessageMiddlewareBuilder {
    return next => middlewares.reduceRight((prev, cur) => cur(prev), next)
}